
const propertySubscribeActions = {
  DO_LIST_PROPERTY_IMAGES: 'DO_LIST_PROPERTY_IMAGES',
  DO_LIST_PROPERTY_IMAGES_SUCCEEDED: 'DO_LIST_PROPERTY_IMAGES_SUCCEEDED',
  DO_LIST_PROPERTY_IMAGES_FAILED: 'DO_LIST_PROPERTY_IMAGES_FAILED',
  DO_MAKE_STRIPE_SUBSCRIBE_PAYMENT: 'DO_MAKE_STRIPE_SUBSCRIBE_PAYMENT',
  DO_MAKE_STRIPE_SUBSCRIBE_PAYMENT_SUCCEEDED: 'DO_MAKE_STRIPE_SUBSCRIBE_PAYMENT_SUCCEEDED',

  doListPropertyImages: response => ({
    type: propertySubscribeActions.DO_LIST_PROPERTY_IMAGES,
    payload: response
  }),
  doListPropertyImagesSucceeded: response => ({
    type: propertySubscribeActions.DO_LIST_PROPERTY_IMAGES_SUCCEEDED,
    payload: response
  }),
  doListPropertyImagesFailed: response => ({
    type: propertySubscribeActions.DO_LIST_PROPERTY_IMAGES_FAILED,
    payload: response
  }),
  doMakeStripeSubscribePayment: response => ({
    type: propertySubscribeActions.DO_MAKE_STRIPE_SUBSCRIBE_PAYMENT,
    payload: response
  }),
  doMakeStripeSubscribePaymentSucceeded: response => ({
    type: propertySubscribeActions.DO_MAKE_STRIPE_SUBSCRIBE_PAYMENT_SUCCEEDED,
    payload: response
  }),
};
export default propertySubscribeActions;



// WEBPACK FOOTER //
// ./src/redux/propertiesSubscribe/actions.js